'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _tabbable = require('tabbable');

var _tabbable2 = _interopRequireDefault(_tabbable);

require('../styles/Item.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_BcReactComponent) {
  _inherits(Item, _BcReactComponent);

  function Item(props) {
    _classCallCheck(this, Item);

    var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).call(this, props));

    _this.elementsToRestore = [];
    return _this;
  }

  _createClass(Item, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.hidden) {
        this.makeContentsUntabbable();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps) {
      if (oldProps.hidden && !this.props.hidden) {
        this.restoreUntabbableContents();
      } else if (!oldProps.hidden && this.props.hidden) {
        this.makeContentsUntabbable();
      }
    }
  }, {
    key: 'makeContentsUntabbable',
    value: function makeContentsUntabbable() {
      var _this2 = this;

      var tabbableElements = (0, _tabbable2.default)(this._itemDiv);
      tabbableElements.forEach(function (element) {
        var tabIndex = element.getAttribute('tabindex');
        _this2.elementsToRestore.push({ element: element, tabIndex: tabIndex });
        element.setAttribute('tabindex', -1);
      });
    }
  }, {
    key: 'restoreUntabbableContents',
    value: function restoreUntabbableContents() {
      this.elementsToRestore.forEach(function (elementData) {
        var element = elementData.element,
            tabIndex = elementData.tabIndex;

        element.setAttribute('tabindex', tabIndex);
      });
      this.elementsToRestore = [];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var hiddenProps = this.props.hidden ? {
        'aria-hidden': true, tabIndex: -1
      } : {};

      var emptyClass = this.props.children ? '' : 'empty';

      return _react2.default.createElement(
        'div',
        _extends({
          ref: function ref(el) {
            return _this3._itemDiv = el;
          },
          className: 'cp-item ' + emptyClass
        }, hiddenProps, {
          style: this.props.styles }),
        this.props.children
      );
    }
  }]);

  return Item;
}(_baseBcReactComponent2.default);

exports.default = Item;


Item.propTypes = {
  hidden: _react.PropTypes.bool,
  children: _react.PropTypes.element
};


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/carousel/base-carousel/lib/components/Item.component.js
// module id = 543
// module chunks = 3 5 6 7